export default "__VITE_ASSET__BKtnRTEi__"